import { HiChevronDown } from 'react-icons/hi';
import { BiTimeFive, BiBuildingHouse } from 'react-icons/bi';
import { AiOutlineMail, AiTwotonePhone } from 'react-icons/ai';
import { FaRegAddressCard } from 'react-icons/fa';
import { BsFillPersonFill, BsCoin } from 'react-icons/bs';
import Steps from './Steps';
import { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Link from 'next/link';
import numeral from 'numeral';
import {
  countTotalPrice,
  countTotal,
  darkenColor,
} from '../../../../utils/helpers';
import { RootReducerState } from '../../../../store/reducer';
import DetailModal from '../../DetailModal/DetailModal';
import InfoTiles from '../../DetailModal/InfoTiles';
import Products from '../../DetailModal/Products';
import ContactDetails from '../../DetailModal/ContactDetails';
import { Booking } from '@deliveries-app/models';
import PaymentModal from '../../../../components/Modals/PaymentModal/PaymentModal';
import {
  deleteBooking,
  holdBooking,
  updateBooking,
  updateBookingDriver,
  uploadProofOfDelivery,
} from '../../../../store/Bookings/actions';
import AsyncToast from '../../../../components/Common/AsyncToast/AsyncToast';
import DeliveredModal from '../../../../components/Modals/DeliveredModal';
import CautionModal from '../../../../components/Modals/Confirmation/Caution';
import moment from 'moment-timezone';

const removeAMPMFromTimeline = (time: string | undefined | any) => {
  const splitTime = time.split(' ');
  const removeAMPM = splitTime.splice(0, 1).join('');

  return removeAMPM;
};

interface BookingTileProps {
  bookingId: number;
  span: number;
  setDraggedBooking: any;
  draggedBooking: any;
  openingHours: any;
  showing: any;
  handleShowTimeline: any;
  timelineRef: any;
  startTime: any;
}

const BookingTile = ({
  span,
  setDraggedBooking,
  bookingId,
  draggedBooking,
  openingHours,
  showing,
  handleShowTimeline,
  timelineRef,
  startTime,
}: BookingTileProps) => {
  const dispatch = useDispatch();
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [deliveredModal, setDeliveredModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [booking, setBooking] = useState<Booking>();

  const { bookings, loading, message, error } = useSelector(
    (state: RootReducerState) => state.bookings
  );

  const { drivers } = useSelector(
    (state: RootReducerState) => state.dashboard.selectedBranch
  );
  const handleDragEnter = (event) => {
    event.preventDefault();

    if (draggedBooking.id == event.target.getAttribute('data-bookingid')) {
      event.target.style.display = 'none';
    }
  };

  const handleDragDrop = (event) => {
    event.preventDefault();
    event.target.style.display = 'flex';
  };

  const getStartTime = useMemo(() => {
    const opening = openingHours.hours.opening_time;
    const total = startTime * 5;
    const hours = parseInt(opening.split(':')[0]) + Math.floor(total / 60);
    const minutes = parseInt(opening.split(':')[1]) + (total % 60);
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
      2,
      '0'
    )}`;
  }, [openingHours, booking]);

  const renderSteps = () => {
    let steps = [];
    switch (booking.status) {
      case 1:
        steps = [
          {
            name: 'Step 1' + booking.id,
            href: '#',
            status: 'current',
          },
          {
            name: 'Step 2' + booking.id,
            href: '#',
            status: 'upcoming',
          },
          {
            name: 'Step 3' + booking.id,
            href: '#',
            status: 'upcoming',
          },
          {
            name: 'Step 4' + booking.id,
            href: '#',
            status: 'upcoming',
          },
        ];
        break;
      case 2:
        steps = [
          {
            name: 'Step 1' + booking.id,
            href: '#',
            status: 'complete',
            date: checkStatus(2),
          },
          {
            name: 'Step 2' + booking.id,
            href: '#',
            status: 'current',
          },
          {
            name: 'Step 3' + booking.id,
            href: '#',
            status: 'upcoming',
          },
          {
            name: 'Step 4' + booking.id,
            href: '#',
            status: 'upcoming',
          },
        ];
        break;
      case 3:
        steps = [
          {
            name: 'Step 1' + booking.id,
            href: '#',
            status: 'complete',
            date: checkStatus(2),
          },
          {
            name: 'Step 2' + booking.id,
            href: '#',
            status: 'complete',
            date: checkStatus(3),
          },
          {
            name: 'Step 3' + booking.id,
            href: '#',
            status: 'current',
            date: '',
          },
          {
            name: 'Step 4' + booking.id,
            href: '#',
            status: 'upcoming',
            date: '',
          },
        ];
        break;
      case 5:
        steps = [
          {
            name: 'Step 1' + booking.id,
            href: '#',
            status: 'complete',
            date: checkStatus(2),
          },
          {
            name: 'Step 2' + booking.id,
            href: '#',
            status: 'complete',
            date: checkStatus(3),
          },
          {
            name: 'Step 3' + booking.id,
            href: '#',
            status: 'complete',
            date: checkStatus(5),
          },
          { name: 'Step 4', href: '#', status: 'current' },
        ];
        break;
      case 6:
        steps = [
          {
            name: 'Step 1' + booking.id,
            href: '#',
            status: 'complete',
            date: checkStatus(2),
          },
          {
            name: 'Step 2' + booking.id,
            href: '#',
            status: 'complete',
            date: checkStatus(3),
          },
          {
            name: 'Step 3' + booking.id,
            href: '#',
            status: 'complete',
            date: checkStatus(5),
          },
          {
            name: 'Step 4' + booking.id,
            href: '#',
            status: 'complete',
            date: checkStatus(6),
          },
        ];
        break;

      default:
        break;
    }
    return steps;
  };

  const infoBookingStep = () => {
    switch (booking?.status) {
      case 2:
        return 'Loaded';
      case 3:
        return 'Onsite';
      case 5:
        return 'Delivered';
      case 6:
        return 'Completed';
      default:
        break;
    }
  };

  const checkStatus = (status: number) => {
    const bookingLast = booking.booking_status_log.find(
      (val) => val.previous_status == status || val.latest_status == status
    );
    if (bookingLast) {
      const strTime = bookingLast.created_at;
      const strDate = moment(strTime);
      const timeComponent = strDate
        .utc()
        .tz(booking.branch.timezone)
        .format('hh:mm A');
      return timeComponent;
    } else {
      return '';
    }
  };

  useEffect(() => {
    setBooking(bookings.find((booking) => booking.id === bookingId));
  }, [bookingId, bookings]);

  useEffect(() => {
    if (booking) {
      renderSteps();
    }
  }, [booking]);

  if (!booking) {
    return null;
  }

  return (
    <>
      <AsyncToast loading={loading} id="booking-tile" error={error} />
      <DetailModal
        booking={booking}
        open={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        onCompleted={() => {
          setDeliveredModal(true);
        }}
        onHold={() => {
          dispatch(holdBooking(booking.branch.id, booking.id));
        }}
        onCharge={() => {
          setShowPaymentModal(true);
        }}
        onDelete={() => {
          setShowCancelModal(true);
        }}
      >
        <InfoTiles booking={booking} />
        <Products booking={booking} />
        <ContactDetails booking={booking} />
      </DetailModal>
      <PaymentModal
        open={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        onSubmit={(data) => {
          // onUpdate({
          //   ...booking,
          //   financial: {
          //     ...booking.financial,
          //     ...data,
          //   },
          // });
          dispatch(
            updateBooking(booking.branch.id, booking.id, {
              ...booking,
              financial: { ...booking.financial, ...data },
            })
          );
          setShowPaymentModal(false);
        }}
        booking={booking}
      />
      <CautionModal
        open={showCancelModal}
        setOpen={() => {
          setShowCancelModal(false);
        }}
        action={() => {
          dispatch(deleteBooking(booking.branch.id, booking.id));
          setShowCancelModal(false);
        }}
        title="Delete Booking"
        body="Are you sure you want to delete this booking? This action cannot be undone."
        actionText={'Delete'}
      />
      <DeliveredModal
        booking={booking}
        open={deliveredModal}
        onClose={() => {
          setDeliveredModal(false);
        }}
        onSubmit={(data) => {
          dispatch(uploadProofOfDelivery(booking.branch.id, booking.id, data));
          setDeliveredModal(false);
        }}
      />

      <div className="w-full">
        <div
          className={`relative row-span-2 mx-2 my-1 flex cursor-grab flex-col overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm ${
            showing == booking.id ? 'z-[15]' : 'z-10'
          } ${booking.on_hold ? 'border-2 border-red-400' : ''}`}
          style={{
            height:
              showing !== booking.id ? `${span * 1.5 - 0.75}rem` : `${27}rem`,
          }}
          data-bookingid={booking.id}
          draggable
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={handleDragEnter}
          onDrop={handleDragDrop}
          onDragEnd={handleDragDrop}
          onDragStart={() =>
            setDraggedBooking({
              ...booking,
              span,
            })
          }
        >
          <div
            className="absolute bottom-0 flex w-full cursor-pointer flex-row items-center justify-end pr-3"
            style={{
              backgroundColor: booking.colour ? booking.colour : '#fff',
            }}
            onClick={() => handleShowTimeline(booking.id)}
          >
            <HiChevronDown
              className={
                showing === booking.id
                  ? 'rotate-180 transition-transform'
                  : 'transition-transform'
              }
            />
          </div>
          <div className="px-3 py-2">
            <div className="mb-1 flex flex-row items-center justify-between gap-x-1 text-sm">
              <span>{booking.id}</span>
              <div className="flex flex-row items-center justify-between py-1.5">
                <Steps
                  branchColour={`${booking.branch.branch_colour}`}
                  steps={renderSteps()}
                />
              </div>
              <div className="flex flex-col">
                <span>{booking.duration} </span>
                <span className="text-xs">Minutes</span>
              </div>
              <div className="flex flex-row justify-end">
                <BsCoin
                  color={
                    booking.financial && booking.financial.invoice_number
                      ? '#8DC63F'
                      : '#E5EBE7'
                  }
                  size={22}
                />
              </div>
            </div>
            <div className="flex flex-row items-center justify-between">
              {booking.anytime ? (
                <span className="inline-flex items-center rounded-full bg-orange-100 px-2.5 py-0.5 text-sm font-medium text-orange-800">
                  A
                </span>
              ) : (
                <></>
              )}
              <div className="w-1/2">
                <select
                  value={booking.driver_id}
                  onChange={(e) =>
                    dispatch(
                      updateBookingDriver(
                        booking.branch.id,
                        booking,
                        parseInt(e.target.value)
                      )
                    )
                  }
                  className="w-full border-0 border-b border-gray-300 bg-transparent py-0 pl-0 placeholder-gray-400 focus:border-gray-500 focus:outline-none focus:ring-transparent sm:text-sm"
                >
                  <option value="">Select Driver</option>
                  {drivers ? (
                    drivers.map((val, index) => (
                      <option value={val.id} key={index}>
                        {val.name}
                      </option>
                    ))
                  ) : (
                    <option value="">-</option>
                  )}
                </select>
              </div>
            </div>

            <div className="mb-2 mt-2 text-center">
              <p
                className={`text-sm`}
                style={{
                  color: booking.branch.branch_colour,
                }}
              >
                {infoBookingStep()}
              </p>
            </div>
            <div className="mt-1 space-y-1 divide-y rounded-md border p-0.5">
              <div className="p-1 text-sm font-medium text-black">
                <div className="flex flex-row items-center">
                  <BsFillPersonFill size={15} />
                  <div className="ml-1">
                    {booking.delivery_location &&
                      booking.delivery_location.name}
                  </div>
                </div>
              </div>
              <div className="p-1 text-sm font-medium text-black">
                <div className="flex flex-row items-center">
                  <BiBuildingHouse size={15} />
                  <div className="ml-1">
                    {booking.company_name ? booking.company_name : ''}
                  </div>
                </div>
              </div>
              {booking.onsite_contact_name && (
                <div className="p-1 text-sm font-medium text-black">
                  <div className="flex flex-row items-center">
                    <AiTwotonePhone size={15} />
                    <div className="ml-1">{booking.onsite_contact_name}</div>
                  </div>
                </div>
              )}
              <div className="p-1 text-sm font-medium text-black">
                <div className="flex flex-row items-center">
                  <FaRegAddressCard size={15} />
                  <div className="ml-2">
                    {booking.delivery_location &&
                      booking.delivery_location.address.slice(0, 60)}
                  </div>
                </div>
              </div>
              <div className="p-1 text-sm font-medium text-black">
                <div className="flex flex-row items-center">
                  <BiTimeFive size={15} />
                  <div className="ml-1">
                    {booking.timeline &&
                      removeAMPMFromTimeline(booking.timeline[2].time)}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-2 flex flex-row justify-between rounded border bg-white p-2 shadow">
              <div className="w-full">
                {booking.booking_line &&
                  booking.booking_line.map((product, index) => (
                    <div
                      key={index}
                      className="false flex flex-row items-center justify-between text-[12px]"
                    >
                      <div className="w-1/2 truncate">
                        {product.product ? product.product.name : ''}
                      </div>
                      <div className="flex w-1/2 flex-row justify-end">
                        <p className="mr-2">
                          {product.quantity} {' x'}
                        </p>
                        <p className="mr-2">
                          {parseFloat(product.weight)} {' Kg'}
                        </p>
                        <p className="mr-2">
                          {parseFloat(product.volume)} M<sup>3</sup>
                        </p>
                        <p>
                          {numeral(parseFloat(product.price)).format('$0,0.00')}
                        </p>
                      </div>
                    </div>
                  ))}

                <div className="mt-2 flex flex-row items-center justify-between border-t-2 pt-2 text-[12px]">
                  <div>Total</div>
                  <div>
                    {booking.booking_line && (
                      <div className="flex flex-1">
                        <p className="mr-2">
                          {countTotal(booking.booking_line).totalWeight} Kg{' '}
                        </p>
                        <p className="mr-2">
                          {countTotal(booking.booking_line).totalVolume} M
                          <sup>3</sup>
                        </p>
                        <p>
                          {booking.financial &&
                            numeral(
                              countTotalPrice(
                                booking.booking_line,
                                booking.financial.delivery_fee
                              ).totalAmount
                            ).format('$0,0.00')}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="p-2">
              <button
                type="button"
                onClick={() => setShowDetailModal(true)}
                className={`w-full rounded-md px-2 py-1 text-white`}
                style={{
                  backgroundColor: booking.branch.branch_colour,
                  color: 'white',
                  width: '100%',
                  borderRadius: '0.375rem', // Equivalent to rounded-md
                  padding: '0.25rem 0.5rem', // Equivalent to px-2 py-1
                  transition: 'background-color 0.3s',
                  cursor: 'pointer',
                  border: 'none', // Ensure no border if that's the desired style
                }}
                onMouseEnter={(e) => {
                  const target = e.currentTarget as HTMLButtonElement;
                  target.style.backgroundColor = darkenColor(
                    booking.branch.branch_colour,
                    20
                  );
                }}
                onMouseLeave={(e) => {
                  const target = e.currentTarget as HTMLButtonElement;
                  target.style.backgroundColor = booking.branch.branch_colour;
                }}
              >
                View
              </button>
            </div>
          </div>
        </div>

        <div
          ref={timelineRef}
          className={
            showing === booking.id
              ? 'relative z-[15] h-auto px-2 pt-2'
              : 'h-auto max-h-0 overflow-hidden'
          }
          style={
            showing === booking.id
              ? {
                  maxHeight: timelineRef.current?.scrollHeight + 'px',
                  transition: '0.4s ease',
                }
              : { maxHeight: 0 + 'px', transition: '0.4s ease' }
          }
        >
          <div className="z-10 rounded-md bg-gray-200 p-2 shadow">
            {booking.timeline ? (
              booking.timeline.map((val, index) => (
                <div key={index} className="flex flex-row ">
                  <div className="w-20 text-[12px]">
                    {removeAMPMFromTimeline(val.time)}
                  </div>
                  <div className="mr-5">
                    <svg
                      width="5"
                      height="6"
                      viewBox="0 0 5 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="2.5"
                        cy="3.3501"
                        r="2.5"
                        fill={index == 2 ? '#8DC63F' : '#FFBB89'}
                      ></circle>
                    </svg>
                    {index !== 4 && (
                      <svg
                        width="5"
                        height="35"
                        viewBox="0 0 1 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          y="0.350098"
                          width="1"
                          height="30.4154"
                          fill={index == 2 ? '#8DC63F' : '#FFBB89'}
                        ></rect>
                      </svg>
                    )}
                  </div>
                  <div className="text-[12px]">{val.title}</div>
                </div>
              ))
            ) : (
              <div>Loading</div>
            )}
          </div>

          <div className="mt-2 flex flex-row justify-between rounded border bg-white p-2 shadow">
            <Link
              href={`mailto:${
                booking.delivery_location && booking.delivery_location.email
              }`}
            >
              <div className="flex cursor-pointer items-center rounded-md px-1.5 py-1.5">
                <AiOutlineMail size={20} />
                <div className="ml-2 text-sm">Send Email</div>
              </div>
            </Link>
            {booking.driver && (
              <div
                style={{
                  backgroundColor: booking.colour ? booking.colour : '#fff',
                  color: booking.colour ? '#fff' : '#000',
                  borderWidth: 1,
                  borderColor: booking.colour ? booking.colour : '#000',
                }}
                className="flex h-8 w-8 items-center justify-center rounded-full font-medium text-white"
              >
                {booking.driver.name.charAt(0)}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingTile;
